import React, { useState } from 'react';
import {
    Box,
    Typography,
    Button,
    Chip,
    Paper,
    IconButton,
    Grid
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import FhItemDetailsPanel from './FhItemDetailsPanel';

const FhItemRow = ({
    fhItem,
    matchedActivity,
    isExpanded,
    onToggleExpand,
    details,
    companyId,
    onImportActivity,
    onSyncActivity
}) => {
    const [syncing, setSyncing] = useState(false);

    const handleSync = async () => {
        setSyncing(true);
        try {
            await onSyncActivity();
        } finally {
            setSyncing(false);
        }
    };

    return (
        <Paper style={{ marginBottom: 12, padding: 16 }} variant="outlined">
            <Grid container spacing={2} alignItems="center">
                {/* Left: FH source info */}
                <Grid item xs={1}>
                    {fhItem.image_cdn_url ? (
                        <img
                            src={fhItem.image_cdn_url}
                            alt={fhItem.name}
                            style={{
                                width: 60,
                                height: 60,
                                objectFit: 'cover',
                                borderRadius: 4
                            }}
                        />
                    ) : (
                        <Box
                            style={{
                                width: 60,
                                height: 60,
                                backgroundColor: '#eee',
                                borderRadius: 4,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            <Typography variant="caption" color="textSecondary">
                                No img
                            </Typography>
                        </Box>
                    )}
                </Grid>

                {/* FH item name and ID */}
                <Grid item xs={4}>
                    <Typography variant="subtitle1" style={{ fontWeight: 500 }}>
                        {fhItem.name}
                    </Typography>
                    <Typography variant="caption" color="textSecondary">
                        FH Item ID: {fhItem.id}
                        {fhItem.is_private && ' (private)'}
                    </Typography>
                </Grid>

                {/* Right: Activiter match status */}
                <Grid item xs={4}>
                    {matchedActivity ? (
                        <Box>
                            <Chip
                                label="Matched"
                                size="small"
                                color="primary"
                                style={{ marginRight: 8 }}
                            />
                            <Typography variant="body2" component="span">
                                {matchedActivity.name}
                            </Typography>
                            <Typography variant="caption" display="block" color="textSecondary">
                                Activity #{matchedActivity.id}
                            </Typography>
                        </Box>
                    ) : (
                        <Chip label="No match" size="small" color="default" />
                    )}
                </Grid>

                {/* Actions */}
                <Grid item xs={3} style={{ textAlign: 'right' }}>
                    {!matchedActivity && (
                        <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            onClick={onImportActivity}
                            style={{ marginRight: 8 }}
                        >
                            Import Activity
                        </Button>
                    )}
                    {matchedActivity && (
                        <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            disabled={syncing}
                            onClick={handleSync}
                            style={{ marginRight: 8 }}
                        >
                            {syncing ? 'Syncing...' : 'Sync Activity'}
                        </Button>
                    )}
                    <IconButton size="small" onClick={onToggleExpand}>
                        {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    </IconButton>
                </Grid>
            </Grid>

            {/* Expanded details panel */}
            {isExpanded && (
                <Box mt={2}>
                    <FhItemDetailsPanel
                        fhItem={fhItem}
                        matchedActivity={matchedActivity}
                        details={details}
                        companyId={companyId}
                    />
                </Box>
            )}
        </Paper>
    );
};

export default FhItemRow;
